<template>
  <div class="page-container" v-if="questionResult">
    <div class="result-container">
      <div class="container-padding">
        <div class="banner-top">
          <div>@明星减脂营营养研究所</div>
          <div>{{ questionResult.add_time }}</div>
        </div>
        <div class="serial-number">{{ questionResult.number }}</div>
        <div class="nutrition-title">
          <div>
            <div class="nutrition-text">营养评估方案</div>
            <div class="desc">国家级专业营养师定制 / 专属于您的饮食方案</div>
          </div>
          <img
            class="stripe-code"
            src="https://cdnvue.gymcity.com.cn/uploads/2e05ca951f78610a95fde14bb32e1cfd.png"
          />
        </div>
        <!--  -->
        <div class="avatar-container">
          <div class="avatar-list">
            <div
              class="avatar-item"
              v-for="(item, index) in questionResult.participation.user_data"
              :key="index"
              :style="{ transform: 'translate(-' + 8 * index + 'px' + ', 0%)' }"
            >
              <img class="avatar-image" :src="item" />
            </div>
          </div>
          <div>{{ questionResult.participation.count || 0 }}位用户改善成功</div>
        </div>
        <!-- 用户信息 -->
        <div class="user-info" v-if="questionResult.user">
          <img
            class="private-custom"
            src="https://cdnvue.gymcity.com.cn/uploads/314c1f445198433f6650d1c05a7b1754.png"
          />
          <div class="info-top">
            <img
              class="avatar"
              :src="questionResult.user.head_img"
              mode="aspectFill"
            />
            <span class="user-name">{{ questionResult.user.name }}</span>
          </div>
          <div class="user-table">
            <div class="table-item">
              <div class="left">性别：{{ questionResult.user.sex }}</div>
              <div class="right">身高：{{ questionResult.user.height }}cm</div>
            </div>
            <div class="table-item">
              <div class="left">年龄：{{ questionResult.user.age }}</div>
              <div class="right">体重：{{ questionResult.user.weight }}kg</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="target">
            <span>目标</span>
            <div class="dash-line"></div>
            <div>{{ questionResult.goal[1] }}</div>
          </div>
          <div class="target-desc">
            <div v-html="questionResult.goal[0]"></div>
          </div>
        </div>
      </div>
      <!-- 切换栏 -->
      <div class="nav-container">
        <div class="nav-list">
          <div
            class="nav-item"
            :class="{ 'nav-item-active': curNav == index }"
            v-for="(item, index) in navList"
            :key="index"
            @click="bindNavChange(index, item.id)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="container-padding">
        <!-- 我的报告 -->
        <div class="my-report" id="nav1">
          <div class="v-flag">报告</div>
          <div class="report-title">
            <div>我的报告</div>
            <div class="shadow"></div>
          </div>
          <!-- bmi指数 -->
          <div class="report-item" v-if="questionResult.bmi">
            <div class="title-upline-top">
              <div class="title-text">身体质量指数(BMI)</div>
              <div class="dashed-line"></div>
              <div class="score">{{ questionResult.bmi.value }}</div>
            </div>
            <v-bmi :bmi="questionResult.bmi.value"></v-bmi>
            <div class="bmi-desc">{{ questionResult.bmi.describe }}</div>
          </div>
          <!-- 生活习惯 -->
          <div class="report-item">
            <div class="title-upline-top">
              <div class="title-text">生活习惯</div>
              <div class="dashed-line"></div>
              <div class="score">良好</div>
            </div>
            <div class="habit-list">
              <div
                class="habit-item"
                v-for="(value, key) in questionResult.life_style.data"
                :key="key"
                v-show="value"
              >
                <div class="left">
                  <img class="icon" :src="iconObj[key]" />
                  <div class="habit-item-center">
                    <div>{{ key }}</div>
                  </div>
                </div>
                <div class="right">
                  <div>{{ value }}</div>
                  <div class="allergy-tips" v-if="key == '过敏原'">
                    （营养方案中已进行脱敏处理）
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 营养风险 -->
          <div class="report-item">
            <div class="title-upline-top">
              <div class="title-text">营养风险</div>
              <div class="dashed-line"></div>
              <div class="score">中</div>
            </div>
            <div class="nutrition-table">
              <div class="vertical-line-list">
                <div
                  class="vertical-line-item"
                  v-for="(item, index) in 4"
                  :key="index"
                  :style="{
                    left: 35 + 61 * (index + 1) + 'px',
                    opacity: 1 - index * 0.1
                  }"
                ></div>
              </div>
              <!-- 过量 -->
              <div
                class="nutrition-table-item"
                v-if="questionResult.nutritional_risk.data.excess.length"
              >
                <div class="nutrition-left">
                  <div
                    class="left-dot"
                    :style="{ backgroundColor: nutritionList['excess'].color }"
                  ></div>
                  <div class="left-text">
                    {{ nutritionList['excess'].desc }}
                  </div>
                </div>
                <div
                  class="nutrition-right"
                  :style="{
                    backgroundImage:
                      'linear-gradient(90deg,' +
                      nutritionList['excess'].startColor +
                      '0,#fff 25%)'
                  }"
                >
                  <div
                    class="nutrition-tag-item"
                    :class="[nutritionList['excess'].size]"
                    v-for="(item1, index1) in questionResult.nutritional_risk
                      .data.excess"
                    :key="index1"
                    :style="{
                      margin: randomMargin(
                        35,
                        30,
                        questionResult.nutritional_risk.data.excess.length
                      )
                    }"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </div>
              <!-- 适中 -->
              <div
                class="nutrition-table-item"
                v-if="questionResult.nutritional_risk.data.moderation.length"
              >
                <div class="nutrition-left">
                  <div
                    class="left-dot"
                    :style="{
                      backgroundColor: nutritionList['moderation'].color
                    }"
                  ></div>
                  <div class="left-text">
                    {{ nutritionList['moderation'].desc }}
                  </div>
                </div>
                <div
                  class="nutrition-right"
                  :style="{
                    backgroundImage:
                      'linear-gradient(90deg,' +
                      nutritionList['moderation'].startColor +
                      '0,#fff 25%)'
                  }"
                >
                  <div
                    class="nutrition-tag-item"
                    :class="[nutritionList['moderation'].size]"
                    v-for="(item1, index1) in questionResult.nutritional_risk
                      .data.moderation"
                    :key="index1"
                    :style="{
                      margin: randomMargin(
                        35,
                        30,
                        questionResult.nutritional_risk.data.moderation.length
                      )
                    }"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </div>
              <!-- 不足 -->
              <div
                class="nutrition-table-item"
                v-if="questionResult.nutritional_risk.data.lack.length"
              >
                <div class="nutrition-left">
                  <div
                    class="left-dot"
                    :style="{ backgroundColor: nutritionList['lack'].color }"
                  ></div>
                  <div class="left-text">{{ nutritionList['lack'].desc }}</div>
                </div>
                <div
                  class="nutrition-right"
                  :style="{
                    backgroundImage:
                      'linear-gradient(90deg,' +
                      nutritionList['lack'].startColor +
                      '0,#fff 25%)'
                  }"
                >
                  <div
                    class="nutrition-tag-item"
                    :class="[nutritionList['lack'].size]"
                    v-for="(item1, index1) in questionResult.nutritional_risk
                      .data.lack"
                    :key="index1"
                    :style="{
                      margin: randomMargin(
                        35,
                        30,
                        questionResult.nutritional_risk.data.lack.length
                      )
                    }"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="report-item">
            <div class="diagnosis-content">
              <div class="title">综合诊断</div>
              <div class="desc">
                饮食生活、运动习惯、休息睡眠与个人健康有着极其密切的关系，不健康的减脂方式更有可能对身体造成不可逆的伤害。摒弃不良生活习惯搭配合理的饮食方案可帮助身体改善营养状况，增强身体素质。
              </div>
            </div>
          </div>
          <!-- 营养师有话说 -->
          <div class="report-item">
            <div class="blue-line"></div>
            <div class="say-title">营养师有话说</div>
            <div class="say-content">
              <div class="say-top">
                <div class="coach-info" v-if="questionResult.dietician">
                  <img
                    class="coach-avatar"
                    :src="questionResult.dietician.url"
                    mode="aspectFill"
                  />
                  <div class="coach-name">
                    {{ questionResult.dietician.name }}
                  </div>
                </div>
                <div class="coach-desc">
                  <div
                    class="coach-desc-item"
                    v-for="(item, index) in questionResult.dietician.card"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="say-text" :class="{ 'limit-text': !isOpen }">
                <div class="say-text-item">
                  亲爱的用户！我是本次为您定制方案的营养师{{
                    questionResult.dietician.name
                  }}，根据您的生活习惯分析，建议您：
                </div>
                <div
                  class="say-text-item"
                  v-for="(item, index) in questionResult.hjjsw"
                  :key="index"
                >
                  <div class="say-text-title">
                    {{ index + 1 }}、{{ item.title }}
                  </div>
                  <div>{{ item.describe }}</div>
                </div>
              </div>
              <div class="open">
                <div class="say-open" @click="changeOpen">
                  {{ isOpen ? '收起' : '展开'
                  }}<span
                    class="iconfont icon-address_down_arrow"
                    :class="{ rotate180: isOpen }"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 营养方案 -->
        <div class="nutrition-plan" id="nav2">
          <div class="v-flag flag-pink">方案</div>
          <div class="report-title">
            <div>营养评估方案</div>
            <div class="nutrition-plan-desc">营养全餐，轻松控卡</div>
            <div class="shadow"></div>
          </div>
          <div
            class="diet-methods-content"
            v-if="questionResult.cookbook.length >= 2"
          >
            <div
              class="methods-item"
              :class="{ 'methods-item-active': curMethod == index }"
              v-for="(item, index) in questionResult.cookbook"
              :key="index"
              @click="changeDietMethod(index)"
            >
              {{ item.name }}
            </div>
          </div>
          <template v-if="questionResult.cookbook.length">
            <div
              v-for="(item, index) in questionResult.cookbook"
              :key="index"
              v-show="index == curMethod"
            >
              <div class="day-nav-list">
                <van-tabs @click="changeDay" class="day-nav-list">
                  <van-tab
                    v-for="(dayitem, dayindex) in item.dayList"
                    :key="dayindex"
                    :title="dayitem"
                  ></van-tab>
                </van-tabs>
              </div>
              <div
                class="food-content"
                v-for="(dayitem, dayindex) in item.data"
                :key="dayindex"
                v-show="dayindex == item.curDay"
              >
                <!-- 每日的食谱 -->
                <div
                  class="content-list"
                  v-for="(mealitem, mealindex) in dayitem.list"
                  :key="mealindex"
                >
                  <div class="meal-type" :class="['meal-type-' + mealindex]">
                    <div class="meal-text">{{ mealitem.title }}</div>
                    <div>{{ mealitem.range }}</div>
                  </div>
                  <div class="meal-list">
                    <div
                      class="meal-item"
                      v-for="(foodtypeitem, foodtypeindex) in mealitem.food"
                      :key="foodtypeindex"
                    >
                      <div class="food-type" v-if="item.index !== 0">
                        {{ foodtypeitem.type_name }}
                      </div>
                      <div class="food-right">
                        <div
                          class="food-right-content flex"
                          v-if="
                            foodtypeitem.type == 'protein' &&
                            foodtypeitem.data.length > 1
                          "
                        >
                          <div class="food-list">
                            <div
                              class="food-item"
                              v-for="(fooditem, foodindex) in foodtypeitem.data"
                              :key="foodindex"
                            >
                              {{ fooditem.name }}({{ fooditem.weight }}g)
                            </div>
                          </div>
                          <div class="food-flex-1">
                            <div
                              class="food-add-icon"
                              v-if="
                                foodtypeitem.data.length > 1 &&
                                foodtypeitem.type == 'protein'
                              "
                            >
                              <div class="food-left-content">
                                <div
                                  class="food-add-item"
                                  v-for="(fooditem, foodindex) in foodtypeitem
                                    .data.length - 1"
                                  :key="foodindex"
                                ></div>
                              </div>
                              <div class="food-right-line"></div>
                            </div>
                            <div class="food-line-icon" v-else>
                              <div
                                class="food-add-item"
                                v-for="(fooditem, foodindex) in foodtypeitem
                                  .data.length"
                                :key="foodindex"
                              ></div>
                            </div>
                          </div>
                          <div class="food-unit">
                            {{ foodtypeitem.data[0].units }}
                            <span v-if="foodtypeitem.sum_weight"
                              >({{ foodtypeitem.sum_weight }}g)</span
                            >
                          </div>
                        </div>
                        <!--  -->
                        <div class="food-right-content" v-else>
                          <div
                            class="food-item"
                            v-for="(fooditem, foodindex) in foodtypeitem.data"
                            :key="foodindex"
                          >
                            <div class="food-name">{{ fooditem.name }}</div>
                            <div class="food-flex-1">
                              <div class="food-line-icon"></div>
                            </div>
                            <div class="food-unit">
                              {{ fooditem.units }}
                              <span v-if="fooditem.weight"
                                >({{ fooditem.weight }}g)</span
                              >
                            </div>
                          </div>
                        </div>
                        <!--  -->
                      </div>
                    </div>
                  </div>
                  <div class="recommend">
                    <span class="recommend-red" v-if="mealitem.menu"
                      >*推荐菜:</span
                    ><span>{{ mealitem.menu }}</span>
                  </div>
                </div>
                <div class="food-tips">
                  *本食谱所有克数代表生重，一拳一掌代表熟重
                </div>
              </div>
            </div>
          </template>
          <!-- 饮食小贴士 -->
          <div
            class="diet-tips"
            v-if="questionResult.diet_tips && questionResult.diet_tips.length"
          >
            <div class="title">饮食小贴士</div>
            <div class="tips-desc">
              问卷中得知您目前存在<span class="risk-text">{{
                questionResult.tipStr
              }}</span
              >，因此在日常饮食中需要注意
            </div>
            <div class="tips-list">
              <div
                class="tips-item"
                v-for="(item, index) in questionResult.diet_tips"
                :key="index"
              >
                <div>
                  <span class="tips-item-num">{{ index + 1 }}</span
                  ><span class="tips-item-text">{{ item.name }}</span>
                </div>
                <div
                  class="tips-item-desc"
                  v-for="(item1, index1) in item.content"
                  :key="index1"
                >
                  <span v-if="item.content.length > 1">{{ index1 + 1 }}、</span
                  >{{ item1 }}
                </div>
              </div>
            </div>
          </div>
          <!-- 喝水 -->
          <div class="drink-content">
            <div class="title-upline-top">
              <div class="drink-plan-title">喝水安排</div>
              <div class="water-ml">
                <img
                  class="cup-image"
                  mode="heightFix"
                  src="https://cdnvue.gymcity.com.cn/uploads/ceb109cec435260736892a8d1383f92c.png"
                /><span>一杯水大概200-250ml</span>
              </div>
            </div>
            <div class="drink-day-list">
              <div
                class="drink-day-item"
                v-for="(item, index) in drinkPlan"
                :key="index"
              >
                <div class="drink-time">{{ item.type }}</div>
                <div class="dirnk-list">
                  <div
                    class="dirnk-item"
                    v-for="(item1, index1) in item.data"
                    :key="index1"
                  >
                    <div class="drink-item-left">{{ item1.time }}</div>
                    <div class="drink-item-dashed"></div>
                    <div class="drink-item-right">
                      <img
                        class="cup-image"
                        mode="heightFix"
                        src="https://cdnvue.gymcity.com.cn/uploads/ceb109cec435260736892a8d1383f92c.png"
                      />
                      <span class="drink-item-unit">*{{ item1.cup }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="nitice-container">
            <img
              class="notice-iamge"
              mode="widthFix"
              src="https://cdnvue.gymcity.com.cn/uploads/65b11b337b2484b73bf95b963b7960e1.png"
            />
          </div>
        </div>
        <!--  -->
        <div class="reduce-fat-content">
          <div>
            <div class="top-line"></div>
            <div class="top-content">
              <div class="title">减脂干货</div>
              <div class="desc">减脂路上踩过的坑，你中招了吗？</div>
            </div>
          </div>
          <div class="question-content">
            <img
              class="question-image"
              v-if="questionResult.test.image_url"
              :src="questionResult.test.image_url"
              mode="widthFix"
            />
            <div class="question-text">{{ questionResult.test.question }}</div>
            <div class="btn-list">
              <div
                class="btn-item"
                :class="{ 'btn-item-active': curAnswer === item.key }"
                @click="selectAnswer(item)"
                v-for="(item, index) in questionResult.test.options"
                :key="index"
              >
                {{ item.key == '0' ? '是' : '不是' }}
              </div>
            </div>
            <div v-if="showResult">
              <div class="result">
                <span
                  class="iconfont"
                  :class="{
                    'icon-kaixin': curAnswer == questionResult.test.right_key,
                    'icon-nanguo': curAnswer != questionResult.test.right_key
                  }"
                ></span>
                <span class="result-text">
                  {{
                    curAnswer == questionResult.test.right_key
                      ? '恭喜你，答对了!'
                      : '很遗憾答错了!'
                  }}</span
                >
              </div>
              <div class="line"></div>
              <div>
                <div class="parsing">答案解析</div>
                <div class="parsing-list">
                  <div class="parsing-item">
                    <div
                      v-if="questionResult.test.analysis"
                      v-html="questionResult.test.analysis"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="publicity-container">
        <img
          class="fat-camp-image"
          mode="widthFix"
          src="https://cdnvue.gymcity.com.cn/uploads/a59a84f27c61aa7a8c4ce02e4179b1aa.png"
        />
        <div class="publicity-padding">
          <div class="line-title-line">学员案例</div>
          <div class="case-container">
            <div class="swiper-dots">
              <div
                class="swiper-dot-item"
                :class="{ 'swiper-dot-item-active': curCase == index }"
                v-for="(item, index) in caseImageList"
                :key="index"
              ></div>
            </div>
            <div class="case-swiper">
              <van-swipe
                @change="changeCase"
                :initial-swipe="curCase"
                :show-indicators="false"
                :loop="false"
              >
                <van-swipe-item
                  v-for="(item, index) in caseImageList"
                  :key="index"
                >
                  <img
                    :src="item"
                    :class="{
                      'case-image-after': curCase + 1 == index,
                      'case-image-before': curCase - 1 == index
                    }"
                    class="case-image"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
            <!-- <swiper
              class="case-swiper"
              previous-margin="90rpx"
              next-margin="90rpx"
              current="{{curCase}}"
              bindchange="changeCase"
            >
              <swiper-item
                class="case-swiper-item"
                wx:for="{{caseImageList}}"
                wx:key="index"
              >
                <img
                  src="{{item}}"
                  mode="aspectFill"
                  class="case-image {{(curCase + 1) == index ? 'case-image-after' : ''}} {{(curCase - 1) == index ? 'case-image-before' : ''}}"
                />
              </swiper-item>
            </swiper> -->
          </div>
          <div class="line-title-line">学员感言</div>
          <!-- 学员感言 -->
          <div class="testimonials-container">
            <div class="swiper-dots">
              <div
                class="swiper-dot-item"
                :class="{ 'swiper-dot-item-active': curTestimonials == index }"
                v-for="(item, index) in curTestimonialsImageList"
                :key="index"
              ></div>
            </div>
            <div class="testimonials-swiper">
              <van-swipe
                @change="changeTestimonials"
                :initial-swipe="curTestimonials"
                :show-indicators="false"
                :loop="false"
              >
                <van-swipe-item
                  v-for="(item, index) in curTestimonialsImageList"
                  :key="index"
                >
                  <img
                    :src="item"
                    :class="{
                      'testimonials-image-after': curTestimonials + 1 == index,
                      'testimonials-image-before': curTestimonials - 1 == index
                    }"
                    class="testimonials-image"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
            <!-- <swiper
              id="testimonials"
              class="testimonials-swiper"
              previous-margin="120rpx"
              next-margin="120rpx"
              current="{{curTestimonials}}"
              bindchange="changeTestimonials"
            >
              <swiper-item
                class="testimonials-swiper-item"
                wx:for="{{curTestimonialsImageList}}"
                wx:key="index"
              >
                <img
                  src="{{item}}"
                  mode="aspectFit"
                  class="testimonials-image {{(curTestimonials + 1) == index ? 'testimonials-image-after' : ''}} {{(curTestimonials - 1) == index ? 'testimonials-image-before' : ''}}"
                />
              </swiper-item>
            </swiper> -->
          </div>
          <!--  -->
        </div>
      </div>
      <!--  -->
      <!-- <div class="bottom-content">
        <div class="feedback-btn" catchtap="jumpToFeedback">填写使用反馈</div>
        <div class="feedback-text" v-if="s_from !== '兑换码领取(转介)'">
          <span>填写使用反馈，还可领取</span>
          <span class="feedback-tip">50元优惠券</span>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import VBmi from './components/bmi-content.vue'
import VTabs from './components/tabs.vue'
import { drinkPlan, coachAvatarList } from './data.js'
export default {
  components: {
    VBmi,
    VTabs
  },
  data() {
    return {
      s_from: '',
      coachAvatarList,
      randomAvatarIndex: 0,
      id: '', //营养评估方案id
      swiperHeight: '', //学员案例的轮播图高度
      screenSize: {
        width: window.screen.width,
        height: window.screen.height
      },
      questionResult: null, //问卷结果
      mealObj: {
        morning: '早餐',
        noon: '午餐',
        evening: '晚餐'
      },
      drinkPlan,
      curAnswer: '',
      feedBackData: [],
      iconObj: {
        饮食: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b8c8e29de008f59d2c13a958d0fd1d91.png',
        运动: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6e418ee40760e62588b2a10526bd7031.png',
        吸烟: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/85a763a80cc1ba194807f696ec0fb72a.png',
        饮酒: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2453d5270fac6f7e74d809d38c4a1a5f.png',
        睡眠: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/93fb6e719868baa1da601658a57c80b2.png',
        过敏原:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/03a4608a1c1954004a07dd6f06c9fd12.png',
        服用药物:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f9f10d29abd9b462bc7a8c8ee463d6ed.png',
        服用补剂:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/69eb0bd75c583f1c2fa4d174b99b41ba.png'
      },
      isOpen: false,
      disabledScroll: false,
      navList: [
        {
          id: 'nav1',
          name: '我的报告'
        },
        {
          id: 'nav2',
          name: '营养方案'
        }
      ],
      curNav: 0,
      habitList: [
        {
          icon: '',
          name: '饮食',
          desc: '膳食结构不合理'
        },
        {
          icon: '',
          name: '运动',
          desc: '运动体力活动不足'
        },
        {
          icon: '',
          name: '吸烟',
          desc: '不吸烟，有被动吸烟'
        },
        {
          icon: '',
          name: '饮酒',
          desc: '偶尔饮酒'
        },
        {
          icon: '',
          name: '睡眠',
          desc: '不充足'
        }
      ],
      nutritionList: {
        excess: {
          desc: '过量',
          color: '#fa5a73',
          startColor: '#FEEDEF',
          tagList: [
            '维A',
            '奶制品',
            '维A',
            '奶制品',
            '维A',
            '奶制品',
            '维A',
            '奶制品'
          ]
        },
        moderation: {
          desc: '适中',
          color: '#6384e8',
          startColor: '#EEF1FC',
          tagList: ['维C', '钙质'],
          size: 'tag-middle',
          line: 1,
          positionArr: [
            { x: 50, y: 50 },
            { x: 200, y: 50 }
          ]
        },
        lack: {
          desc: '不足',
          color: '#979da5',
          startColor: '#F8F8F8',
          tagList: ['维B2', '铁'],
          size: 'tag-small',
          line: 1,
          positionArr: [
            { x: 50, y: 50 },
            { x: 200, y: 50 }
          ]
        }
      },
      caseImageList: [
        'https://cdnvue.gymcity.com.cn/uploads/e3abab27b12fa3325f0c0cc141ff3887.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/77206da699194ad83428915ff8dd3a80.png',
        'https://cdnvue.gymcity.com.cn/uploads/deb0e354eb3631385e7a1db75b5fdbb9.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/11e8b48c9ea60033e5e41642037a7d71.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/36c5e020812836fdf410c2a0e7089195.jpg'
      ],
      curTestimonialsImageList: [
        'https://cdnvue.gymcity.com.cn/uploads/86d87c3b2f9807017d2df5a8c2753f38.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/01577f92fcb14956dd44ff4cf5d6ae05.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/dd0afc9366bdf5cbfc38ba6c3ab35186.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/aa5810638959120e8ac3a6c517b1d506.jpg',
        'https://cdnvue.gymcity.com.cn/uploads/e086730be27c9b9e08028b37bccc0460.jpg'
      ],
      dayList: [],
      curDay: 0,
      curCase: 0,
      curTestimonials: 0,
      showResult: false, //是否显示答案
      bmi: 22.5,
      curMethod: 0
    }
  },
  created() {
    let options = this.$route.query
    this.id = (options && +options.id) || ''
    this.s_from = (options && options.s_from) || ''
  },
  mounted() {
    this.getResultData()
  },
  methods: {
    randomMargin(column, row, num) {
      var mingap = parseInt(20 / (parseInt(num / 4) || 1))
      column = parseInt(column / (parseInt(num / 4) || 1))
      row = parseInt(row / (parseInt(num / 4) || 1))
      var top = mingap + Math.floor(Math.random() * (column - 2 * mingap))
      var bottom = column - top
      var left = mingap + Math.floor(Math.random() * (row - 2 * mingap))
      var right = row - left
      return top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px'
    },
    //切换饮食方案
    changeDietMethod(index) {
      this.curMethod = index
    },
    getResultData() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      let param = {
        rid: this.id,
        check_token: this.$route.query.check_token || ''
      }
      this.$http
        .getApp('member/AppCamp/posterDetailV3', param)
        .then((res) => {
          this.$toast.clear()
          res = res.data
          if (res.code == 200) {
            res.data = this.dealResultData(res.data)
            this.feedBackData = res.data.couple_back_data || []
            this.questionResult = res.data
            this.curMethod = res.data.is_take_out == 2 ? 1 : 0
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast.clear()
        })
    },
    dealResultData(data) {
      let cookbook = [
        {
          index: 1,
          name: '自制方案',
          data: data.cookbook,
          curDay: 0
        }
      ]
      if (data.take_out_cookbook) {
        cookbook.unshift({
          index: 0,
          name: '外食方案',
          data: data.take_out_cookbook,
          curDay: 0
        })
      }
      cookbook.map((item) => {
        item.dayList = item.data.map((item1, index) => {
          return '第' + (index + 1) + '天'
        })
      })
      data.cookbook = cookbook
      if (data.diet_tips && data.diet_tips.length) {
        let tipStr = ''
        data.diet_tips.map((item, index) => {
          if (!Array.isArray(item.content)) {
            item.content = [item.content]
          }
          if (index >= data.diet_tips.length - 1) {
            tipStr = tipStr + item.name
          } else {
            tipStr = tipStr + item.name + '、'
          }
        })
        data.tipStr = tipStr
      }
      return data
    },
    jumpToFeedback() {
      if (this.feedBackData.length) {
        localStorage.setItem('feedbackData', JSON.stringify(this.feedBackData))
        wx.navigateTo({
          url:
            '/package-recipe/pages/questionnaire/feedbackStatus/index?s_from=' +
            this.data.s_from
        })
      } else {
        wx.navigateTo({
          url:
            '/package-recipe/pages/questionnaire/feedback/index?id=' +
            this.data.id +
            '&s_from=' +
            this.data.s_from
        })
      }
    },
    //选择答案时
    selectAnswer(item) {
      if (this.showResult) {
        return
      }
      let key = item.key
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认选择该答案？'
        })
        .then(() => {
          this.curAnswer = key
          this.showResult = true
        })
        .catch(() => {
          // on cancel
        })
    },
    bindNavChange(index, id) {
      this.curNav = index
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
    },
    changeTestimonials(index) {
      this.curTestimonials = index
    },
    changeCase(index) {
      this.curCase = index
    },
    changeDay(index) {
      this.questionResult.cookbook[this.curMethod].curDay = index
    },
    changeOpen() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
<style lang="scss">
.day-nav-list {
  .van-tabs__line {
    display: none;
  }
  .van-tab__text {
    color: #979da5;
  }
  .van-tab--active .van-tab__text {
    font-weight: 600;
    font-size: 5.33vw;
    color: #fa5a73;
  }
}
</style>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
}
.container-padding {
  padding: 0px 4.27vw;
}
.result-container {
  width: 100%;
  padding: 5.33vw 0vw 0vw;
  box-sizing: border-box;
  background-image: url(https://cdnvue.gymcity.com.cn/uploads/f17d592f214d281f55feda56dc91f6ab.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top center;
  background-color: rgb(241, 241, 241);
}
.banner-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 3.2vw;
  color: #fff;
  padding-bottom: 1.33vw;
  border-bottom: 1px solid #fff;
  margin-bottom: 0.8vw;
}

.serial-number {
  line-height: 6.67vw;
  font-family: DIN-Light;
  font-size: 5.33vw;
  letter-spacing: 1px;
  color: #253e89;
  text-shadow: 0px 0px 0px #708fea, 0px 1px 0px #708fea, 0px 2px 0px #7693eb;
  margin-bottom: 2.13vw;
}
.say-text-title {
  font-weight: 600;
}
.nutrition-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4.27vw;
}

.nutrition-text {
  font-family: PingFangSC-Semibold;
  font-size: 10.93vw;
  line-height: 15.2vw;
  color: #fff;
  margin-bottom: 0.53vw;
}
.stripe-code {
  height: 16vw;
  margin-right: 3.2vw;
}
.nutrition-title .desc {
  font-size: 3.2vw;
  color: #fff;
  line-height: 4.53vw;
}

.avatar-container {
  display: flex;
  align-items: center;
  font-size: 3.47vw;
  color: #fff;
  margin-bottom: 3.47vw;
}

.avatar-list {
  display: flex;
  align-items: center;
}

.avatar-container .avatar-item {
  width: 4.53vw;
  height: 4.53vw;
  border-radius: 50%;
  overflow: hidden;
  border: solid 0.53vw #6385e8;
}
.avatar-container .avatar-item .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info {
  overflow: hidden;
  position: relative;
  background-color: #fff;
  border-radius: 1.6vw;
  padding: 4vw 5.6vw;
  box-sizing: border-box;
  margin-bottom: 4.27vw;
}

.user-info .avatar {
  width: 13.07vw;
  height: 13.07vw;
  background-color: #d8d8d8;
  border-radius: 7.2vw;
  margin-right: 4.27vw;
}

.user-info .private-custom {
  position: absolute;
  top: -4.8vw;
  right: -3.2vw;
  width: 23.2vw;
  height: 23.2vw;
  z-index: 2;
}

.info-top {
  display: flex;
  align-items: center;
  margin-bottom: 3.47vw;
}

.user-info .user-name {
  font-size: 7.47vw;
  letter-spacing: 1px;
  color: #202025;
}

.user-table {
  margin-bottom: 4vw;
}

.user-table .table-item {
  padding: 0vw 4.8vw;
  box-sizing: border-box;
  height: 8.53vw;
  line-height: 8.53vw;
  font-size: 3.47vw;
  color: #202025;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-table .table-item:nth-child(2n + 1) {
  background-color: #f6f7f8;
}

.user-table .left,
.user-table .right {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info .line {
  height: 0.53vw;
  background-color: #f2f2f2;
  margin-bottom: 5.33vw;
}

.user-info .target {
  display: flex;
  align-items: center;
  font-size: 5.33vw;
  color: #202025;
  margin-bottom: 1.33vw;
}

.user-info .dash-line {
  flex: 1;
  overflow: hidden;
  height: 0vw;
  border-bottom: 0.27vw dashed #202025;
  margin: 0vw 4vw 0vw 4.53vw;
}

.target-desc {
  font-size: 3.2vw;
  line-height: 5.07vw;
  color: #979da5;
}
.nav-container {
  position: sticky;
  width: 100%;
  z-index: 99;
  top: 2.67vw;
  padding: 0vw 4.27vw;
  box-sizing: border-box;
}
.nav-list {
  height: 11.73vw;
  line-height: 11.73vw;
  background-color: #fff;
  border-radius: 5.87vw;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-bottom: 4.27vw;
}

.nav-item {
  box-sizing: border-box;
  width: 42.4vw;
  text-align: center;
  font-size: 4.27vw;
  color: #979da5;
}

.nav-item-active {
  width: 49.07vw;
  color: #fff;
  background-image: linear-gradient(90deg, #628df8 0%, #2755e0 100%);
  border-radius: 5.87vw;
}

.my-report {
  overflow: hidden;
  position: relative;
  padding: 5.33vw;
  padding-bottom: 0vw;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 1.6vw;
  margin-bottom: 4.27vw;
}
.v-flag {
  position: absolute;
  right: 0vw;
  top: 0vw;
  background-color: #6385e8;
  width: 26.67vw;
  height: 8vw;
  padding-bottom: 1.33vw;
  color: #fff;
  z-index: 2;
  display: flex;
  font-size: 3.2vw;
  align-items: flex-end;
  transform: translate(50%) rotate(45deg);
  transform-origin: center top;
  justify-content: center;
}
.flag-pink {
  background-color: #fa5a73;
}
.report-title {
  position: relative;
  font-size: 5.33vw;
  color: #202025;
  margin-bottom: 4vw;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.report-title .shadow {
  position: absolute;
  bottom: 0vw;
  left: 0vw;
  z-index: 0;
  width: 22.13vw;
  height: 2.4vw;
  background-image: linear-gradient(
    180deg,
    rgba(156, 186, 245, 0.1) 0%,
    #6384e8 100%
  );
}
.report-item {
  padding-bottom: 9.6vw;
}
.title-upline-top {
  position: relative;
  padding-top: 2.67vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6.67vw;
}
.title-upline-top::after {
  content: '';
  position: absolute;
  top: 0vw;
  left: 0vw;
  width: 11.2vw;
  height: 0.53vw;
  background-color: #202025;
}

.report-item .dashed-line {
  height: 0vw;
  flex: 1;
  overflow: hidden;
  border-bottom: 0.27vw dashed #202025;
  margin-left: 5.07vw;
  margin-right: 3.73vw;
}

.bmi-content {
  margin-bottom: 5.87vw;
}

.bmi-desc {
  font-size: 3.2vw;
  line-height: 5.33vw;
  color: #979da5;
}
.habit-item .left {
  display: flex;
  align-items: center;
}
.habit-item {
  display: flex;
  align-items: center;
  font-size: 3.2vw;
  color: #202025;
  padding: 2.93vw 4.27vw 2.67vw;
  box-sizing: border-box;
}
.habit-list .habit-item:nth-child(2n + 1) {
  background-color: #f6f7f8;
}
.habit-item .icon {
  width: 4.27vw;
  height: 4.27vw;
  margin-right: 4vw;
}
.habit-item .left {
  margin-right: 5.33vw;
}
.habit-item-center {
  max-width: 20vw;
}
.allergy-tips {
  font-size: 2.67vw;
}
.habit-item .right {
  text-align: right;
  flex: 1;
}
.food-tips {
  text-align: center;
  font-size: 3.2vw;
}
.nutrition-table {
  position: relative;
}
.nutrition-table-item {
  display: flex;
  align-items: center;
}
.nutrition-table-item .nutrition-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 3.73vw;
}
.nutrition-table-item .nutrition-right {
  position: relative;
  flex: 1;
  overflow: hidden;
  min-height: 21.87vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border-left: 0.27vw solid #d1d3d6;
  border-bottom: 0.27vw solid #d1d3d6;
}
.nutrition-table-item .left-text {
  writing-mode: vertical-lr;
}
.left-dot {
  width: 2.67vw;
  height: 2.67vw;
  border-radius: 50%;
  background-color: #fa5a73;
  margin-bottom: 1.6vw;
}
.vertical-line-list {
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.vertical-line-item {
  position: absolute;
  height: 100%;
  width: 0.27vw;
  background-color: #f2f2f2;
  top: 0vw;
  left: 0vw;
}
.nutrition-tag-item {
  width: 13.33vw;
  height: 13.33vw;
  padding: 0.8vw;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2vw;
  color: #fff;
  z-index: 2;
}
.nutrition-right .nutrition-tag-item:nth-child(4n) {
  margin-right: 0vw !important;
}
.tag-big {
  background-image: linear-gradient(180deg, #fd93ab 0%, #fa5a73 100%);
}
.tag-middle {
  background-image: linear-gradient(180deg, #9cbaf5 0%, #6384e8 100%);
}
.tag-small {
  background-image: linear-gradient(180deg, #c8ccd1 0%, #979da5 100%);
}
.blue-line {
  width: 11.2vw;
  height: 0.8vw;
  background-color: #2a58e1;
  margin-bottom: 2.4vw;
}
.say-title {
  font-size: 4.27vw;
  color: #2a58e1;
  font-weight: 600;
  margin-bottom: 6.93vw;
}
.say-top {
  background-image: url('https://cdnvue.gymcity.com.cn/uploads/ff1be8d3eca3fba82b8c460f7e5e186e.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 2.93vw 5.33vw 1.33vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.say-content {
  background-color: #f6f7f8;
  border-radius: 1.6vw;
  overflow: hidden;
}
.say-content .coach-avatar {
  width: 13.87vw;
  height: 13.87vw;
  border-radius: 50%;
  overflow: hidden;
  background-color: #d8d8d8;
  margin-bottom: 1.07vw;
}
.say-content .coach-info {
  margin-right: 5.87vw;
}
.say-content .coach-name {
  text-align: center;
  line-height: 5.87vw;
  font-size: 4.27vw;
  letter-spacing: 0.27vw;
  color: #fff;
}
.say-content .coach-desc {
  line-height: 4.27vw;
  font-size: 2.93vw;
  color: #fff;
}
.say-content .coach-desc-item {
  padding-left: 2.67vw;
  position: relative;
}
.say-content .coach-desc-item::after {
  position: absolute;
  content: '';
  width: 1.07vw;
  height: 1.07vw;
  border-radius: 50%;
  left: 0vw;
  top: 2.13vw;
  transform: translate(0%, -50%);
  background-color: #fff;
}
.say-content .say-text {
  overflow: hidden;
  padding: 3.73vw 4.8vw 0vw;
  box-sizing: border-box;
  font-size: 3.47vw;
  line-height: 5.87vw;
  color: #202025;
}
.say-text .say-text-item {
  margin-bottom: 3.2vw;
}
.say-text .say-text-item:last-child {
  margin-bottom: 0vw;
}
.say-content .open {
  text-align: center;
  padding-bottom: 2.67vw;
  font-size: 3.2vw;
  color: rgba(32, 32, 37, 0.5);
}
.say-content .open .iconfont {
  font-size: 2.67vw;
  margin-left: 1.07vw;
}
.say-open {
  display: flex;
  align-items: center;
  justify-content: center;
}
.say-content .rotate180 {
  transform: rotate(180deg);
}
.limit-text {
  max-height: 36.27vw;
  /* display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical; */
}
.nutrition-plan {
  overflow: hidden;
  position: relative;
  background-color: #fff;
  border-radius: 1.6vw;
  padding: 5.33vw 5.6vw;
  box-sizing: border-box;
  margin-bottom: 4.27vw;
}
.nutrition-plan .shadow {
  background-image: linear-gradient(
    180deg,
    rgba(247, 222, 226, 0.1) 0%,
    #fa5a73 100%
  );
}
.nutrition-plan-desc {
  font-size: 3.2vw;
  color: rgba(32, 32, 37, 0.5);
}
.day-nav-list {
  width: 100%;
  margin-bottom: 2.67vw;
}
.food-content {
  margin-bottom: 10.67vw;
}
.food-content .content-list {
  margin-bottom: 6.93vw;
}
.food-content .content-list:last-child {
  margin-bottom: 0vw;
}
.food-content .meal-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 3.47vw;
  color: #202025;
  height: 8.53vw;
  line-height: 8.53vw;
  background-color: #e6f8f5;
  padding: 0vw 3.73vw;
  box-sizing: border-box;
}
.food-content .meal-type-1 {
  background-color: rgb(253, 240, 223);
}
.food-content .meal-type-2 {
  background-color: rgb(228, 234, 251);
}
.food-content .meal-type-3 {
  background-color: rgb(254, 233, 236);
}
.food-content .meal-text {
  font-size: 4.27vw;
  font-weight: 600;
  color: #202025;
}
.food-content .meal-item {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 1.87vw 3.73vw;
  box-sizing: border-box;
}
.food-content .meal-list .meal-item:nth-child(2n + 1) {
  background-color: #f6f7f8;
}
.food-content .food-type {
  width: 18.13vw;
  line-height: 5.33vw;
  font-size: 3.2vw;
  display: flex;
  align-items: flex-start;
  color: #979da5;
  margin-right: 2.67vw;
}
.food-content .food-list {
  flex-shrink: 0;
  overflow: hidden;
  font-size: 3.2vw;
  color: #000;
  margin-right: 2.67vw;
}
.food-content .flex .food-list {
  max-width: 18.67vw;
}
.meal-list .food-right {
  font-size: 3.2vw;
  flex: 1;
  overflow: hidden;
  flex-shrink: 0;
}
.meal-list .food-right-content {
  width: 100%;
}
.food-content .food-flex-1 {
  flex-shrink: 0;
  overflow: hidden;
  min-width: 8vw;
  flex: 1;
  display: flex;
  align-items: center;
  margin-right: 2.67vw;
}
.meal-list .food-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.meal-list .food-name {
  margin-right: 2.67vw;
  line-height: 5.33vw;
}
.food-content .food-left-content {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.food-content .food-right-line {
  width: 8vw;
  height: 0vw;
  border-bottom: 0.27vw dashed #202025;
}
.food-content .food-unit {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 3.2vw;
  color: #000;
}
.food-content .food-add-icon {
  width: 100%;
  display: flex;
  align-items: center;
}
.food-content .food-line-icon {
  width: 100%;
  height: 0vw;
  margin-right: 2.67vw;
  border-bottom: 0.27vw dashed #202025;
}
.food-content .food-add-item {
  box-sizing: border-box;
  width: 100%;
  height: 8.53vw;
  border-right: 0.27vw dashed #202025;
  border-bottom: 0.27vw dashed #202025;
}
.food-content .food-left-content .food-add-item:first-child {
  border-top-right-radius: 1.33vw;
  border-top: 0.27vw dashed #202025;
}
.food-content .food-left-content .food-add-item:last-child {
  border-bottom-right-radius: 1.33vw;
}
.recommend {
  margin-top: 4.27vw;
  font-size: 3.2vw;
  color: #000;
}
.recommend-red {
  font-size: 3.2vw;
  color: #fa5a73;
  margin-right: 2.67vw;
  line-height: 4vw;
}
.drink-plan-title {
  font-size: 4.27vw;
  color: #202025;
  font-weight: 600;
}
.water-ml {
  display: flex;
  align-items: center;
  font-size: 3.2vw;
  color: #979da5;
  margin-left: 1.87vw;
}
.cup-image {
  height: 3.73vw;
}
.drink-time {
  font-size: 4.27vw;
  color: #202025;
  margin-bottom: 2.4vw;
  font-weight: 600;
}
.drink-day-item {
  margin-bottom: 6.93vw;
}
.dirnk-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6vw;
}
.drink-item-left {
  font-size: 3.47vw;
  color: #202025;
}
.drink-item-dashed {
  flex: 1;
  overflow: hidden;
  height: 0vw;
  border-bottom: 0.27vw dashed #202025;
  margin-left: 2.13vw;
  margin-right: 2.67vw;
}
.drink-item-right {
  display: flex;
  align-items: center;
}
.drink-item-unit {
  font-size: 3.2vw;
  color: #000;
  margin-left: 2.4vw;
}
.drink-content {
  margin-bottom: 9.6vw;
}
.nitice-container {
  margin-bottom: 4.27vw;
}
.notice-iamge {
  width: 100%;
}
.reduce-fat-content {
  background-color: #9fb3ef;
  border-radius: 1.6vw;
  padding: 6.4vw 4.27vw;
  box-sizing: border-box;
  margin-bottom: 4.27vw;
}
.reduce-fat-content .top-line {
  width: 13.07vw;
  height: 0.8vw;
  background-color: #fff;
  margin-bottom: 1.87vw;
}
.reduce-fat-content .title {
  font-size: 5.33vw;
  color: #fff;
  font-weight: 600;
}
.reduce-fat-content .desc {
  font-size: 3.47vw;
  color: #fff;
}
.reduce-fat-content .top-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.93vw;
}
.reduce-fat-content .question-content {
  background-color: #fff;
  border-radius: 1.6vw;
  padding: 4.27vw 4.27vw 7.2vw;
  box-sizing: border-box;
}
.reduce-fat-content .question-image {
  width: 100%;
  margin-bottom: 2.67vw;
}
.reduce-fat-content .question-text {
  margin-bottom: 4.27vw;
}
.reduce-fat-content .btn-item {
  width: 100%;
  height: 11.73vw;
  background-color: #f2f2f2;
  border-radius: 5.87vw;
  margin-bottom: 2.67vw;
  text-align: center;
  line-height: 11.73vw;
  box-sizing: border-box;
}
.reduce-fat-content .btn-item-active {
  border: 0.27vw solid #6384e8;
}
.reduce-fat-content .btn-list {
  margin-bottom: 4.27vw;
}
.reduce-fat-content .result {
  display: flex;
  align-items: center;
  justify-content: center;
}
.reduce-fat-content .result-text {
  font-size: 5.33vw;
  font-weight: 600;
  color: #202025;
}
.reduce-fat-content .iconfont {
  margin-right: 2.13vw;
  font-size: 5.6vw;
}
.reduce-fat-content .icon-kaixin {
  color: #43c572;
}
.reduce-fat-content .icon-nanguo {
  color: rgb(228, 58, 58);
}
.reduce-fat-content .line {
  width: 100%;
  height: 0.53vw;
  background-color: #f2f2f2;
  margin: 4.8vw 0vw 4.27vw;
}
.reduce-fat-content .parsing {
  font-size: 3.47vw;
  color: #202025;
  margin-bottom: 2.67vw;
}
.parsing-item {
  display: flex;
  align-items: flex-start;
  font-size: 3.2vw;
  line-height: 5.07vw;
  color: #202025;
}
.parsing-item-index {
  margin-right: 2.67vw;
}
.fat-camp-image {
  width: 100%;
}
.publicity-container {
  background-color: #ffd4cc;
}
.publicity-padding {
  padding: 4.27vw 5.87vw;
  box-sizing: border-box;
}
.publicity-container .line-title-line {
  position: relative;
  font-size: 5.33vw;
  font-weight: 600;
  text-align: center;
  color: #000;
  margin-bottom: 4.27vw;
}
.publicity-container .line-title-line::before {
  position: absolute;
  content: '';
  left: 0vw;
  top: 50%;
  width: 28vw;
  height: 0vw;
  border-bottom: 0.27vw dashed #202025;
}
.publicity-container .line-title-line::after {
  position: absolute;
  content: '';
  width: 28vw;
  height: 0vw;
  right: 0vw;
  top: 50%;
  border-bottom: 0.27vw dashed #202025;
}
.testimonials-container,
.case-container {
  background-color: #fff;
  border-radius: 1.6vw;
  padding: 8vw 0vw 9.87vw;
  box-sizing: border-box;
  margin-bottom: 4.27vw;
}
.swiper-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4.27vw;
}
.swiper-dot-item {
  width: 1.33vw;
  height: 1.33vw;
  border-radius: 50%;
  background-color: #e9e9e9;
  margin: 0vw 1.73vw;
}
.swiper-dot-item-active {
  background-color: #979da5;
}
.case-swiper {
  padding: 0vw 12vw;
  box-sizing: border-box;
  height: 42.13vw;
}
.case-swiper-item {
  width: 59.73vw;
  height: 42.13vw;
  overflow: hidden;
  border-radius: 1.6vw;
}
.case-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 1.6vw;
}
.case-image-before {
  transform: translate(2.67vw) rotateY(-20deg) scale(0.8);
  transition: all 0.3s ease;
  opacity: 0.2;
}
.case-image-after {
  transform: translate(-2.67vw) rotateY(20deg) scale(0.8);
  transition: all 0.3s ease;
  opacity: 0.2;
}
.testimonials-swiper {
  padding: 0vw 16vw;
  box-sizing: border-box;
  height: 121.33vw;
}
.testimonials-swiper-item {
  width: 100%;
  height: 100%;
}
.testimonials-image {
  border-radius: 1.6vw;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.testimonials-image-before {
  transform: translate(0vw) rotateY(-20deg) scale(0.8);
  transition: all 0.3s ease;
  opacity: 0.2;
}
.testimonials-image-after {
  transform: translate(0vw) rotateY(20deg) scale(0.8);
  transition: all 0.3s ease;
  opacity: 0.2;
}
.bottom-content {
  background-color: #fff;
  padding: 16vw 11.73vw;
  box-sizing: border-box;
}
.qrcode-content {
  margin: 0 auto;
  margin-bottom: 4.27vw;
  width: 54.4vw;
  height: 54.4vw;
  background-color: #f0f0f0;
  border-radius: 1.6vw;
  padding: 2.67vw;
  box-sizing: border-box;
}
.qrcode-image {
  width: 100%;
  height: 100%;
}
.qrcode-center {
  text-align: center;
  line-height: 8vw;
  border-bottom: 0.27vw solid #f2f2f2;
  margin-bottom: 8vw;
  padding-bottom: 6.67vw;
  font-size: 5.33vw;
  color: #000;
}
.qrcode-center .iconfont {
  margin-bottom: 3.47vw;
  font-size: 5.33vw;
}
.feedback-btn {
  height: 11.73vw;
  line-height: 11.73vw;
  text-align: center;
  color: #fff;
  background-image: linear-gradient(90deg, #618cf7 0%, #3562e5 100%);
  border-radius: 5.87vw;
  margin-bottom: 2.67vw;
}
.feedback-text {
  text-align: center;
  font-size: 3.47vw;
  color: #979da5;
}
.feedback-tip {
  padding: 0vw 1.6vw;
  height: 5.33vw;
  font-size: 3.47vw;
  line-height: 5.33vw;
  background-color: rgb(254, 236, 239);
  color: #fa5a73;
  margin-left: 1.07vw;
}
.diagnosis-content {
  background-color: #fef1e8;
  border-radius: 1.6vw;
  padding: 4.27vw 5.33vw 6.93vw;
  box-sizing: border-box;
}
.diagnosis-content .title {
  font-family: PingFangSC-Medium;
  font-size: 4.27vw;
  font-weight: 600;
  color: #903836;
  margin-bottom: 2.13vw;
}
.diagnosis-content .desc {
  font-family: PingFangSC-Regular;
  font-size: 3.47vw;
  line-height: 5.87vw;
  color: #903836;
}
.diagnosis-content .desc .bold {
}
.diagnosis-content .code {
  display: block;
  width: 41.6vw;
  height: 41.6vw;
  margin: 4.8vw auto 5.87vw auto;
}
.diagnosis-content .tips {
  text-align: center;
  position: relative;
  padding: 2.13vw 5.33vw;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px -0.53vw 1.6vw 0vw rgba(144, 56, 54, 0.04);
  border-radius: 1.6vw;
  font-family: PingFangSC-Medium;
  font-size: 3.47vw;
  line-height: 5.6vw;
  font-weight: 600;
  color: #000000;
}
.diagnosis-content .tips .circle {
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 2.67vw solid #fff;
  border-top: none;
  border-left: 2.67vw solid transparent;
  border-right: 2.67vw solid transparent;
  left: 50%;
  top: -2.67vw;
  transform: translate(-50%);
}
.diet-tips {
  background: #f6f7f8;
  border-radius: 1.6vw;
  padding: 5.33vw;
  box-sizing: border-box;
  margin-bottom: 9.6vw;
}
.diet-tips .title {
  display: inline-block;
  height: 5.33vw;
  background: #fa5a73;
  border-radius: 0.53vw;
  padding: 0vw 1.6vw;
  line-height: 5.33vw;
  font-size: 3.47vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 2.13vw;
}
.diet-tips .tips-desc {
  font-size: 3.47vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 5.87vw;
  margin-bottom: 4.27vw;
}
.diet-tips .risk-text {
  line-height: 4.8vw;
  background: #fff8cb;
}
.diet-tips .tips-list .tips-item {
  margin-bottom: 1.07vw;
}
.diet-tips .tips-list .tips-item:last-child {
  margin-bottom: 0vw;
}
.diet-tips .tips-item-num {
  padding: 0vw 1.07vw;
  height: 3.47vw;
  background: #ef354e;
  font-size: 2.67vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 3.47vw;
  border-radius: 1.2vw;
  margin-right: 2.13vw;
}
.diet-tips .tips-item-text {
  font-size: 3.47vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 5.6vw;
}
.diet-tips .tips-item-desc {
  margin-top: 0.8vw;
  font-size: 3.47vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 5.87vw;
}
.diet-methods-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.27vw solid #f2f2f2;
}
.diet-methods-content .methods-item {
  padding: 2.93vw 6.27vw;
  box-sizing: border-box;
  font-size: 5.33vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979da5;
  line-height: 7.47vw;
}
.diet-methods-content .methods-item-active {
  position: relative;
  color: #202025;
  font-weight: 600;
}
.diet-methods-content .methods-item-active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0%);
  width: 9.07vw;
  height: 0.8vw;
  background-color: #fa5a73;
}
</style>
